import { ICoordinates } from '../tracking/entities';
import { LatLngStatic } from './entities';
import { IStop, StopActionType } from '../tracking/entities';
import { find, some } from 'lodash';

export const ConvertCoord = (loc: ICoordinates | undefined | null) => {
    let lat = 0,
        lng = 0;

    if (loc) {
        lng = loc.longitude ? loc.longitude : 0;
        lat = loc.latitude ? loc.latitude : 0;
    }
    return new LatLngStatic(lat, lng);
};

export const FindStoppoint = (stops: IStop[] | undefined | null, actionType: StopActionType): IStop | null => {
    if (!stops || stops.length === 0) {
        return null;
    }
    const stop = find(stops, stop => some(stop.actions, action => action.type === actionType));
    if (!stop) {
        return null;
    }
    return stop;
};

export const GetDayOfTheWeekString = (index: number) => {
    switch (index) {
        case 0:
            return 'Sunday';
        case 1:
            return 'Monday';
        case 2:
            return 'Tuesday';
        case 3:
            return 'Wednesday';
        case 4:
            return 'Thursday';
        case 5:
            return 'Friday';
        default:
            return 'Saturday';
    }
};
